import React from 'react';
import {
  HeaderText,
  BodyText,
  Stack,
} from '../../../ui';

export type ProfileDepositPolicyProps = {
  depositPolicyText: string;
  providerName: string;
  centered?: boolean;
};

/**
 * Deposit policy for a pro
 */
export const AboutProDepositPolicy: React.FC<ProfileDepositPolicyProps> = ({
  depositPolicyText,
  centered,
  providerName,
}) => (
  <Stack alignItems={centered ? 'center' : undefined} space={12}>
    <HeaderText level="4" textAlign={centered ? 'center' : undefined}>
      {providerName ? `${providerName}'s` : ''} Deposit Policy
    </HeaderText>
    <BodyText
      appearance="small"
      weight="thin"
      textAlign={centered ? 'center' : undefined}
      testID="depositPolicy--text"
    >
      {depositPolicyText}
    </BodyText>
  </Stack>
);
